import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as MicrophoneIcon } from './microphone.svg';
import { ReactComponent as CameraIcon } from './camera.svg';
import { ParcelItemsAiControlsContainer } from './styles';

interface Props {
  canRecordVoice: boolean;
  disabled: boolean;
  disabledReason?: string;
  onSpeak: () => void;
  onScan: () => void;
}

const ParcelItemsAiControls = ({
  canRecordVoice,
  disabled,
  disabledReason,
  onSpeak,
  onScan,
}: Props) => {
  const { t } = useTranslation();
  const disabledReasonId = useId();

  return (
    <ParcelItemsAiControlsContainer className='ai-search-actions'>
      {canRecordVoice && (
        <span
          className='ai-action-trigger'
          title={disabledReason ? undefined : t('parcel_items_ai_speak')}>
          <button
            type='button'
            aria-label={t('parcel_items_ai_speak')}
            aria-describedby={disabledReason ? disabledReasonId : undefined}
            onClick={onSpeak}
            disabled={disabled}>
            <MicrophoneIcon aria-hidden='true' />
          </button>
        </span>
      )}
      <span
        className='ai-action-trigger'
        title={disabledReason ? undefined : t('parcel_items_ai_scan')}>
        <button
          type='button'
          aria-label={t('parcel_items_ai_scan')}
          aria-describedby={disabledReason ? disabledReasonId : undefined}
          onClick={onScan}
          disabled={disabled}>
          <CameraIcon aria-hidden='true' />
        </button>
      </span>
      {disabledReason && (
        <span
          id={disabledReasonId}
          className='ai-review-tooltip'
          role='tooltip'>
          {disabledReason}
        </span>
      )}
    </ParcelItemsAiControlsContainer>
  );
};

export default ParcelItemsAiControls;
